import SubMenu from "./subMenu";
import { Link } from "react-router-dom";
import React, { useState } from "react";

const Navmenu = ({ link, text, icon, type, hasCount, count, subItems }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  if (type == "treeview") {
    return (
      <li className={`${type} ${isOpen ? 'menu-open' : ''}`}>
        <a href="#" onClick={handleToggle}>
          <i className={icon} /> <span>{text}</span>
          <span className="pull-right-container">
            <i className={`fa fa-angle-left pull-right ${isOpen ? 'fa-angle-down' : ''}`} />
          </span>
        </a>
        <ul className="treeview-menu" style={{ display: isOpen ? 'block' : 'none' }}>
          {subItems.map(({ name, subLink, status }, index) => (
            <SubMenu
              key={index}
              name={name}
              subLink={subLink}
              status={status}
            />
          ))}
        </ul>
      </li>
    );
  } else {
    return (
      <li>
        <Link to={link}>
          <i className={icon} /> <span>{text}</span>
        </Link>
      </li>
    );
  }
};

export default Navmenu;
